module.exports = __webpack_public_path__ + "img/member.e8dc8d85.svg";